export const routes = {
    root: '/',
    authorization: '/authorization',
    passwordRecovery: '/passwordRecovery',
    registration: '/registration',
    rules: '/rules',
    rule: '/rule',
    userFiltes: '/userFiltes',
    userProfile: '/userProfile',
    currentBiddings: '/currentBiddings',
    completedBiddings: '/completedBiddings',
    favoriteBiddings: '/favoriteBiddings',
    payment: '/payment',
    biddingCard: '/bidding/:id'
}